
import { Component, Prop, Vue } from "vue-property-decorator";
import store from "@/store";

@Component
export default class ButtonSwitchCorporate extends Vue {
  @Prop({ default: "別の所属先IDに切り替える" })
  label!: string;

  @Prop()
  to?: string;

  private async handleSwitchCorporateId() {
    if (store.getters["auth/line"]) {
      await store.dispatch("auth/lineDelete");
    }

    const route: { path: string; query?: { to: string } } = { path: "/logout" };
    if (this.to) {
      route.query = { to: this.to };
    }
    this.$router.push(route);
  }
}
